export default __webpack_public_path__ + "static/media/ev-4.6ac9a90c.jpg";